export default __webpack_public_path__ + "static/media/p4.56da8714.jpg";